export enum InputType {
  Text,
  Password,
  Textarea,
  Number,
  Select,
  Date,
  Radio,
  Checkbox,
  InputGroup,
  SwitchButton,
  SwitchButtonWithDescription,
}
